/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../../client.ts';
import type {
  SitemapControllerGetSitemapPartQueryResponse,
  SitemapControllerGetSitemapPartPathParams,
  SitemapControllerGetSitemapPartHeaderParams,
  SitemapControllerGetSitemapPart404,
  SitemapControllerGetSitemapPart503,
} from '../../types/SitemapControllerGetSitemapPart.ts';
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from '@tanstack/react-query';
import { sitemapGetSitemapPart } from '../../methods/sitemapGetSitemapPart.ts';
import { queryOptions, useQuery } from '@tanstack/react-query';

export const sitemapGetSitemapPartQueryKey = (key: SitemapControllerGetSitemapPartPathParams['key']) =>
  [{ url: '/api/sitemap/parts/:key', params: { key: key } }] as const;

export type SitemapGetSitemapPartQueryKey = ReturnType<typeof sitemapGetSitemapPartQueryKey>;

export function sitemapGetSitemapPartQueryOptions(
  key: SitemapControllerGetSitemapPartPathParams['key'],
  headers?: SitemapControllerGetSitemapPartHeaderParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = sitemapGetSitemapPartQueryKey(key);
  return queryOptions<
    SitemapControllerGetSitemapPartQueryResponse,
    ResponseErrorConfig<SitemapControllerGetSitemapPart404 | SitemapControllerGetSitemapPart503>,
    SitemapControllerGetSitemapPartQueryResponse,
    typeof queryKey
  >({
    enabled: !!key,
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return sitemapGetSitemapPart(key, headers, config);
    },
  });
}

/**
 * @summary Stream a published XML sitemap part for the current website.
 * {@link /api/sitemap/parts/:key}
 */
export function useSitemapGetSitemapPart<
  TData = SitemapControllerGetSitemapPartQueryResponse,
  TQueryData = SitemapControllerGetSitemapPartQueryResponse,
  TQueryKey extends QueryKey = SitemapGetSitemapPartQueryKey,
>(
  key: SitemapControllerGetSitemapPartPathParams['key'],
  headers?: SitemapControllerGetSitemapPartHeaderParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        SitemapControllerGetSitemapPartQueryResponse,
        ResponseErrorConfig<SitemapControllerGetSitemapPart404 | SitemapControllerGetSitemapPart503>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? sitemapGetSitemapPartQueryKey(key);

  const query = useQuery(
    {
      ...sitemapGetSitemapPartQueryOptions(key, headers, config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<SitemapControllerGetSitemapPart404 | SitemapControllerGetSitemapPart503>
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
